import { render, staticRenderFns } from "./ControlConfigure.vue?vue&type=template&id=2a5df09b&scoped=true"
import script from "./ControlConfigure.vue?vue&type=script&lang=js"
export * from "./ControlConfigure.vue?vue&type=script&lang=js"
import style0 from "./ControlConfigure.vue?vue&type=style&index=0&id=2a5df09b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_6m5rqjauvbyej62p7eiecas4wq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5df09b",
  null
  
)

export default component.exports